"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawBboxes = void 0;
var tslib_1 = require("tslib");
var draw_bbox_points_1 = require("./draw-bbox-points");
var drawBboxes = function (ctx, bboxes, styles) {
    var e_1, _a, e_2, _b;
    ctx.strokeStyle = styles.borderColor;
    if (styles.borderDashLengthPx !== undefined) {
        ctx.setLineDash([styles.borderDashLengthPx, styles.borderDashLengthPx]);
    }
    ctx.lineWidth = styles.borderWidthPx;
    ctx.shadowColor = styles.borderColor;
    ctx.shadowBlur = 0;
    try {
        for (var _c = tslib_1.__values(bboxes.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var bbox = _d.value;
            var _e = bbox.rect, top_1 = _e.top, left = _e.left, width = _e.width, height = _e.height;
            ctx.strokeRect(left, top_1, width, height); // draw border lines
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    ctx.setLineDash([]);
    ctx.shadowBlur = styles.borderShadowWidthPx;
    if (styles.showPoints) {
        /* draw inactive bbox points */
        ctx.fillStyle = styles.borderColor;
        try {
            for (var _f = tslib_1.__values(bboxes.values()), _g = _f.next(); !_g.done; _g = _f.next()) {
                var bbox = _g.value;
                (0, draw_bbox_points_1.drawBboxPoints)(ctx, bbox, styles.pointWidthPx);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
};
exports.drawBboxes = drawBboxes;
